let disciplineSelect = document.getElementById("formFieldDiscipline");
let programsSelect = (document.getElementById("tuitionCalculator-input-program")) ? document.getElementById("tuitionCalculator-input-program") : document.getElementById("formFieldPrograms");

let formInit = true;
if (disciplineSelect !== null) {
  disciplineSelect.addEventListener("change", function () {
    let programsSelect = (document.getElementById("tuitionCalculator-input-program")) ? document.getElementById("tuitionCalculator-input-program") : document.getElementById("formFieldPrograms");
    let tag = this.value;

    programsSelect.value = ""; //reset back to empty when the area of study changes
    // programsSelect.options[0].innerHTML = "Select A Program";

    // For each option in programsSelect, check if the tag matches the option's value.
    // if it doesn't, add the hidden attribute
    for (let i = 0; i < programsSelect.options.length; i++) {
      let option = programsSelect.options[i];

      console.log(option.dataset.tag);
      console.log(tag);

      // Compare the slugified data-tag attribute to the tag
      if (option.dataset.tag !== tag) {
        // Set the hidden attributre
        option.setAttribute("hidden", true);
        option.setAttribute("disabled", true);
        // Add the d-none class
        option.classList.add("d-none");
      } else {
        option.removeAttribute("hidden");
        option.removeAttribute("disabled");
        option.classList.remove("d-none");
      }
    }

    if (!formInit) {
      programsSelect.removeAttribute("disabled");
    }
  });

  if ("createEvent" in document) {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("change", false, true);
    disciplineSelect.dispatchEvent(evt);
  } else {
    disciplineSelect.fireEvent("onchange");
  }

  formInit = false;
}

if (programsSelect !== null) {
  programsSelect.addEventListener("change", function (e) {
    let amaInput = document.getElementById("formFieldAma");
    let program = programsSelect.options[programsSelect.selectedIndex];
    let programData = program.dataset;

    amaInput.value = programData.ama;
  });
}
